import { render } from "./audio_markup_player.vue?vue&type=template&id=54a515c7"
import script from "./audio_markup_player.vue?vue&type=script&lang=js"
export * from "./audio_markup_player.vue?vue&type=script&lang=js"

import exportComponent from "/home/sophia/sophia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__